import React, { useRef } from "react";
import PropTypes from "prop-types";

import Button from "../Button/Button";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HOME_PATH } from "../../Constants/GlobalConstant";

import styles from "./Card.module.scss";

const Card = (props) => {
    const cardRef = useRef();

    let bodyClasses = "";
    if (props.extended)
        bodyClasses += " " + styles.extended;

    return (
        <div ref={cardRef} className="card">
            {props.header &&
                <div>
                    <div className="card-header">
                        <div>
                            <h5 className="card-title">{props.title}</h5>
                            <h6 className="card-subtitle">{props.subtitle}</h6>
                        </div>
                        {props.icon && <div className="card-header-icon">
                            <div className="card-icon" >
                                <Button
                                    className="btn-grid btn-xl"
                                    onClick={props.onClick}
                                    tooltipTitle={props.label}
                                    icon={props.icon}
                                    style={{ fontSize: "1,2rem" }}
                                    spinner={props.spinner}
                                />
                            </div>
                        </div>}
                    </div>
                </div>
            }

            <div className={styles.cardBody + bodyClasses}>
                <div className={"h-100 " + props.className}>
                    {props.children}
                </div>
            </div>

            {props.action &&
                <div className="card-action">
                    {props.action}
                </div>
            }

            {props.footer &&
                <div><hr />
                    <div className={styles.cardFooter}>
                        <FontAwesomeIcon icon={faClock} className="mr-2 text-primary" />
                        <p>{props.footer}</p>
                    </div>
                </div>
            }
        </div>
    );
}

Card.defaultProps = {
    title: "",
    subtitle: "",
    footer: "",
    header: true,
    link: HOME_PATH,
    type: "blue",
    extended: false,
    to: "/home",
    className: "",
    label: "",
    spinner: false
}

Card.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    footer: PropTypes.string,
    header: PropTypes.bool,
    link: PropTypes.string,
    type: PropTypes.string,
    extended: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
    action: PropTypes.any,
    children: PropTypes.any,
    spinner: PropTypes.bool

};


export default (Card);